import {useQuery} from '@apollo/client'
import {TWILIO_PROVISIONING_STATUS} from '../gql/queries/twilioNumbers'

/**
 * Whether the current agent may self-provision Twilio numbers. Backed by the
 * per-agent `twilioProvisioningStatus.enabled` flag an admin toggles. Used to
 * show/hide the "My Numbers" entry point. Apollo caches the result, so calling
 * it from the sidebar costs a single request per session.
 */
export const useCanProvisionNumbers = (): {enabled: boolean; loading: boolean} => {
  const {data, loading} = useQuery(TWILIO_PROVISIONING_STATUS, {
    fetchPolicy: 'cache-first',
    errorPolicy: 'ignore',
  })
  return {enabled: !!data?.twilioProvisioningStatus?.enabled, loading}
}
